import { ArrowRightIcon } from "@phosphor-icons/react";
import Link from "next/link";
import { Button } from "./ui/button";

export default function CallToAction() {
  return (
    <div className="container mx-auto">
      <div className="px-6 py-16 lg:flex lg:items-center lg:justify-between lg:px-6">
        <h2 className="mb-5 text-balance bg-linear-to-br from-emerald-100 via-white to-emerald-100 bg-clip-text pb-3 text-2xl font-bold tracking-tight text-transparent md:mb-0 md:max-w-3xl md:text-4xl">
          Ready to supercharge your automotive ecommerce store with Partbot?
        </h2>
        <div className="flex space-x-5 space-y-0 md:space-y-4">
          <Button asChild size="lg" className="bg-emerald-500">
            <Link href="/contact">
              <span className="mr-2">Contact Us</span>
              <ArrowRightIcon className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
